angular.module('impactx.retoure').controller('RetoureListCtrl', [
    'selectedListItems',
    RetoureListCtrl
]);

function RetoureListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewRetoure'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/retoure/templates/retourelist.row.tmpl.html',
        isSelectAble: true,
        hasDateFilter: true,
        ctrl: this,
        endpoint: '/retoure/list',
        id: "retoure",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "retoure/" + selectedListItems.getFirstSelectedId();
    }
}